import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 12px;
  background: #fafafa;
  width: 100%;
`;

export const ValueRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  font-size: 0.95rem;
  word-break: break-all;
`;